import React, { useState } from "react";
import { DocumentCard, 
    DocumentCardDetails, 
    DocumentCardTitle, 
    DocumentCardActivity, 
    DocumentCardLocation, 
    DefaultButton, 
    TooltipHost,
    Icon,
    Link} from '@fluentui/react';
import EditModal from "../EditSite/EditModal";
import { PowerAppProvisioningStatus, PowerAppBaseType } from "../../GlobalConst/globalEnums";
import { mapUserForPeople } from "../../helpers/HelperMethods";
import PowerAppSolutionEditModal from "../EditSite/PowerAppSolutionEditModal";

const SinglePowerApp = ({ app, callBack, solutionCallBack }) => {

    const [showModal, setShowModal] = useState(false);
    const [showSolutionModal, setShowSolutionModal] = useState(false);
    const [solutionId, setSolutionId] = useState(null);

    const onEditClick = () => setShowModal(true);

    const onLocationClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        window.open(e.target.href, '_blank');
    };

    const closeModal = () => setShowModal(false);

    //const truncateTitle = (title) => title.length > 30 ? `${title.substr(0, 30)}...` : title;

    const handleShowSolutionModal = (solutionId) => {
        setShowModal(false);
        setSolutionId(solutionId);
        setShowSolutionModal(true);
    };

    const handleCloseSolutionModal = () => setShowSolutionModal(false);
    
    const logoClass = (type) => {
        switch (type) {
            case PowerAppBaseType.powerApp:
                return 'powerAppLogo'
            case PowerAppBaseType.flow:
                return 'flowLogo'
            case PowerAppBaseType.agent:
                return 'copilotLogo'
            default:
                return ''
        }
    }
    const logo = <span className={`cardLogo ${logoClass(app.type)}`} />;

    const environmentUrl = `https://make.${app.type === PowerAppBaseType.flow ? 'powerautomate' : 'powerapps'}.com/environments/${app.environment.internalId}/home`;

    let updatesIcon;
    let btnEdit;

    if ([PowerAppProvisioningStatus.updating, PowerAppProvisioningStatus.pendingApproval, PowerAppProvisioningStatus.failed, PowerAppProvisioningStatus.permanentFailed].includes(app.provisioningStatus)) {
        updatesIcon = (
            <TooltipHost content='Updates are in progress' styles={iconStyles}>
                <Icon iconName='workflow' style={updatesIconStyles} />
            </TooltipHost>
        );
    } else {
        btnEdit = <DefaultButton text='Details' onClick={onEditClick} styles={btnEditStyles} />;
    }

    const premiumIcon = app.isPremium && (
        <TooltipHost content="Uses Premium Connectors" styles={premiumIconStyles}>
            <Icon iconName="diamond" />
        </TooltipHost>
    );

    const isUsingAiFeaturesBanner = 
            app.isUsingAiFeatures &&
            <div style={{backgroundColor: '#ff9600', color: 'white', padding: '5px 8px', fontSize: '14px'}}>
                Uses AI features (may incur cost)
            </div>

    const borderColor = (app) => {
        if(app.isUsingAiFeatures)
            return '#ff9600'
        
        switch (app.type)
        {
            case PowerAppBaseType.powerApp:
                return 'rgb(116, 39, 116)'
            case PowerAppBaseType.flow:
                return 'rgb(0, 102, 255)'
            default:
                return 'rgb(138, 136, 134)'
        }
    }

    return (
        <div>
            <DocumentCard styles={cardStyles(borderColor(app))}>
                {isUsingAiFeaturesBanner}
                <DocumentCardDetails styles={detailsStyles}>
                    <div style={headerStyles}>
                        {logo}
                        <div style={titleContainerStyles}>
                            <DocumentCardTitle title={app.name} shouldTruncate={true} styles={titleStyles} />
                        </div>
                        <div style={iconContainerStyles}>
                            {premiumIcon}
                            {updatesIcon}
                            {btnEdit}
                        </div>
                    </div>
                    <div style={ownersStyles}>
                        <DocumentCardActivity 
                            activity={`Primary owner`} 
                            people={mapUserForPeople(app.primaryOwner)}
                            styles={ownerStyles}
                        />
                        <DocumentCardActivity 
                            activity={`Secondary owner`} 
                            people={mapUserForPeople(app.secondaryOwner)} 
                            styles={ownerStyles}
                        />
                    </div>
                    <DocumentCardLocation
                        styles={urlStyles}
                        location={app.name}
                        locationHref={app.url}
                        onClick={onLocationClick}
                    />
                    <div style={statusStyles}>Environment: <Link href={environmentUrl} target='_blank'>{app.environment.name}</Link></div>
                </DocumentCardDetails>
            </DocumentCard>
            <EditModal
                onCloseModal={closeModal}
                isModalOpened={showModal}
                itemId={app.id}
                callBack={callBack}
                isPowerApp={true}
                showSolutionModal={handleShowSolutionModal}
            />
            <PowerAppSolutionEditModal
                solutionId={solutionId}
                showModal={showSolutionModal}
                callback={solutionCallBack}
                onCloseModal={handleCloseSolutionModal}
            />
        </div>
    );
}

const premiumIconStyles = {
    root: {
        fontSize: 20,
        margin: '7px 5px', 
        cursor: 'default'
    }
}

const urlStyles = {
    root: {
        color: 'rgb(0, 120, 212)'
    }
}
const statusStyles = {
    padding: '10px 16px 20px',
    fontSize: '12px'
}

const btnEditStyles = {
    root: {
        margin: '6px',
        height: '24px',
        minWidth: '40px'
    },
    label: {
        fontWeight: 400
    }
}

const iconContainerStyles = {
    display: 'flex'
}

const iconStyles = {
    root: {
        margin: '10px 10px 10px 0'
    }
}

const updatesIconStyles = {
    color: 'orange',
    cursor: 'default'
}

const headerStyles = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
}

const cardStyles = (borderColor) => ({
    root: {  
        marginRight: 20, 
        marginBottom: 20, 
        width: 400,
        maxWidth: 400,
        height: 200,
        border: '1px solid ' + borderColor
    }
})

const detailsStyles = {
    // root: {
    //     height: 140
    // }
}

const titleContainerStyles = {
    display: 'flex',
    height: 54,
    flex: 1,
    alignItems: 'center',
    overflow: 'hidden'
}

const titleStyles = {
    root: {
        flexGrow: 1,
    }
}

const ownersStyles = {
    display: 'flex',
    justifyContent: 'space-between'
}

const ownerStyles = {
    root: {
        width: 200
    }
}

export default SinglePowerApp


// WEBPACK FOOTER //
// ./src/components/ManageCenter/SinglePowerApp.js